<template>
  <div class="box7">
    <pageTitle
      title="从0到1全流程实践主流行业项目<br/>积累高质量企业项目经验"
      text="多场景+高价值  强化实战能力对标大厂优秀人才标准"
      titleColor="#3E4F48"
      titColor="#4E5969"
    />

    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in projectList"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.num }}
          </div>
          <div class="seat"></div>
        </div>
      </div>
      <swiper
        :options="swiperOption"
        ref="mySwiper"
        class="swiperitems"
        :class="cur == 3 || cur == 4 || cur == 5 ? 'swiperitemspecial' : ''"
      >
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in projectList"
          :key="index"
          :class="index == 3 || index == 4 || index == 5 ? 'swiperwrap2' : ''"
        >
          <img class="img" :src="item.img" alt="" />
          <div class="projectName">
            {{ item.name }}
          </div>
          <div class="projectDesc">{{ item.txt }}</div>
          <div class="btn">查看全部</div>
        </swiper-slide>
      </swiper>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div class="block">
        <div class="block-tops">
          <div class="title">{{ projectList[this.cur].name }}</div>
          <div class="close" @click="show = false"></div>
        </div>

        <div class="exp">{{ projectList[this.cur].txt }}</div>

        <div class="tag">项目亮点</div>
        <div class="target">
          <p v-for="j in projectList[this.cur].lightPoint" :key="j">{{ j }}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,
      nav: ["数据看板", "面经", "智慧园区", "医疗", "社区生活", "电商"],
      projectList: [
        {
          num: "项目一",
          img: require("../../../assets/coursePage/web/box7/1.png"),
          name: "数据看板",
          href: "",
          txt: "数据看板是一个数据可视化项目，通过折线图、K线图、柱状图等图表形式归纳汇总大量数据，以实现更加直观的数据表达效果。学员通过学习该项目，能够掌握数据可视化、异步编程、实时数据获取等技术解决方案，适合有基础希望技能强化的IT人员继续学习。",
          lightPoint: [
            "基于 bootstrap 的响应式页面布局方案",
            "基于 echarts 的数据可视化解决方案",
            "基于 token 的访问权限控制解决方案",
          ],
        },
        {
          num: "项目二",
          img: require("../../../assets/coursePage/web/box7/2.png"),
          name: "面经全端（PC端+移动端）",
          href: "",
          txt: "面经系统，由⾯试经验⽂章PC管理后台，个⼈H5端⾯试⽂章浏览组成。学员学习该项⽬，能够锻炼对Vue完整技术栈的运⽤。同时该项⽬还涵盖了token身份认证、Vue组件库、⽂件上传、富⽂本编辑器等前端技术解决⽅案，移动端开发，适合刚⼊⼿Vue框架、希望通过项⽬开发来巩固 Vue基础的前端开发者学习。",
          lightPoint: [
            "token身份认证解决⽅案",
            "⽂件上传解决⽅案",
            "富⽂本编辑解决⽅案",
            "表单验证解决⽅案",
            "基于 token 的访问权限控制解决⽅案",
            "基于postcss-px-to-viewport移动端适配⽅案",
          ],
        },
        {
          num: "项目三",
          img: require("../../../assets/coursePage/web/box7/3.png"),
          name: "黑马智数",
          href: "https://pip.itcast.cn/web-hmzs",
          txt: "黑马智数是一个数字化园区管理项目，该项目后台可以在线管理园区内的楼宇、企业、车辆和一体杆等资源，可视化大屏通过园区3D模型实时展示园区概况。学员通过该项目能学到如何用qiankun搭建微前端架构、用Echarts进行数据可视化、以及前沿的3D模型展示等技术方案。",
          lightPoint: [
            "基于element-ui 和 vue2大型中台项目开发解决方案",
            "基于axios封装请求工具模块解决方案",
            "基于token的前端登录解决方案",
            "vuex分模块持久化解决方案",
            "RBAC 项目权限控制解决方案",
            "基于qiankun企业内中后台项目的拆分维护",
            "基于spline工具底层为 three.js 的3D模型交互",
            "多语言动态主题解决方案",
            "无限列表滚动解决方案"
          ],
        },
        {
          num: "项目四",
          img: require("../../../assets/coursePage/web/box7/4.png"),
          name: "优医问诊",
          href: "https://pip.itcast.cn/web-yywz",
          txt: "优医问诊是⼀个连接医⽣和患者的移动医疗⾏业H5应⽤，通过⾼效、快速的在线问诊服务，为患者提供健康帮助，涵盖了找医⽣、快速问诊、开药⻔诊、疾病查询，健康健康百科等功能。该项⽬基于 Vue3+TypeScript 进⾏开发，且引⼊下⼀代状态管理⼯具Pinia和热⻔的前端移动UI组件库 Vant ，采⽤全新技术栈，给学员带来优秀的企业实战项⽬，助⼒学员⾼薪就业。",
          lightPoint: [
            "基于vue3.0+typescript中⼤型项⽬开发解决⽅案",
            "基于pinia的状态管理解决⽅案",
            "基于vant组件库快速构建H5界⾯解决⽅案",
            "基于vue-router的前端路由解决⽅案",
            "基于vite构建vue3.0项⽬解决⽅案",
            "第三⽅⽀付解决⽅案",
            "基于eruda 的移动端调试解决⽅案",
            "第三⽅登录解决⽅案",
            "@vuecore/use的组合API⼯具库解决⽅案",
          ],
        },
        {
          num: "项目五",
          img: require("../../../assets/coursePage/web/box7/5.png"),
          name: "享+生活原生小程序",
          href: "",
          txt: "享+社区是一个生活类的小程序项目，主要服务于小区业主，为其提供生活家电报修、访客门禁通行的的功能，该项目主要包含房屋管理、报修管理、访客管理、用户管理、通知管理等功能模块，技术栈以原生小程序技术为主配合了Vant 组件库。",
          lightPoint: [
            "微信小程序 vant 组件解决方案",
            "微信请求工具解决方案",
            "微信用户登录和登录状态检测解决方案",
            "腾讯位置服务实现地理定位检索解决方案",
            "微信二维码服务解决方案"
          ],
        },
        {
          num: "项目六",
          img: require("../../../assets/coursePage/web/box7/6.png"),
          name: "美蔻商城（鸿蒙）",
          href: "",
          txt: '美蔻商城是一个"一对多"的电商购物应用，提供在线购物的核心服务，业务涵盖了商品列表、商品详情、购物车、商品评价、订单管理等功能。 项目基于鸿蒙一对多开发范式，采用了三层工程架构配合多种UI适配方式，最终实现"一次开发，多端部署"的核心目标。同时，也应用了鸿蒙系统的多种能力，比如多媒体技术、支付能力、混合开发等等。',
          lightPoint: [
            "【一次开发多端部署】媒体查询+栅格系统实现界面一多，SysCap实现功能一多，三层har架构实现工程一多等方案",
            "【账号服务】基于华为登录实现用户一键登录功能方案",
            "【智能搜索】基于华为AI能力实现语音转文字，涉及录音和语音识别功能方案",
            "【物流轨迹】基于华为Map服务实现物流轨迹，涉及路径规划、轨迹绘制、地理定位功能方案",
            "【状态推送】基于华为Push服务实现消息推送，涉及服务端通过AGC推送订单状态、物流状态消息方案",
            "【Hybird开发】基于Web组件实现客服系统与支付宝支付，涉及Web组件通信、Web资源监听方案",
            "【应用卡片】基于FormAbility实现商品推荐与物流状态卡，涉及卡片与宿主应用数据通信和交互方案",
            "【情亲付】基于华为分布式应用流转能力实现情亲代付功能，涉及分布式流转能力和Want意图框架使用方案",
            "【通用SKU组件】基于HarmonyOS Next封装通用能力组件，涉及使用sku算法实现规格可选功能方案"
          ],
        },
      ],
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            console.log(that.cur);
            document.getElementsByClassName("scorll-box6")[0].scrollLeft =
              this.realIndex * 68;
          },
          click(e) {
            if (e.target.className == "btn" || that.$refs.mySwiper) {
              that.show = true;
              that.mai("HTML&JS+前端-就业课","查看全部",0,that.projectList[that.cur].name)
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);

      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/web/box7/bgc.png") no-repeat;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }

  .subject-box {
    position: relative;
    margin: 48px auto 0;
    // padding-bottom: 22px;
    width: 100%;

    .swiperwrap {
      width: 100%;
      margin-top: 48px;

      .img {
        width: 600px;
        height: 360px;
        object-fit: contain;
        display: block;
        margin: 0 auto;
      }
      .projectName {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        text-align: center;
        margin: 76px 0 16px;
        img {
          width: 32px;
          height: 32px;
          position: absolute;
          margin-left: 8px;
        }
      }
      .projectDesc {
        width: 654px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        background: linear-gradient(
          180deg,
          #86909c 0%,
          rgba(134, 144, 156, 0) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
      }
      .btn {
        width: 180px;
        height: 56px;
        background: linear-gradient(129deg, #0ccb84 0%, #25ceed 100%);
        box-shadow: 0px 8px 24px 0px rgba(64, 255, 137, 0.12);
        border-radius: 32px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56px;
        text-align: center;
        margin: 24px auto 0px;
      }
    }
    .swiperwrap2 {
      margin-top: 0;
      height: auto;
      .img {
        width: 600px !important;
        height: 540px !important;
      }
      .projectName {
        margin-top: 32px;
      }
      .projectDesc {
        -webkit-line-clamp: 2;
      }
    }
    .scorll-box6 {
      overflow-x: auto;
      transition: all 0.2s;
      width: 100%;
      padding-right: 30px;
      box-sizing: border-box;
      height: 100%;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
  }
  .nav-box {
    display: flex;
    justify-content: space-between;
    margin: 0 32px 0 32px;
    position: relative;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #4e5969;
    width: 100%;
    height: 116px;
    box-sizing: border-box;
    .nav {
      flex-shrink: 0;
      width: 138px;
      height: 68px;
      background: #ffffff;
      border-radius: 8px;

      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 68px;
      margin-right: 20px;
      text-align: center;
      box-sizing: border-box;
    }
    .nav:nth-child(6) {
      margin-right: 0;
    }
    .seat {
      width: 32px;
      flex-shrink: 0;
    }
    .cur-nav {
      background: linear-gradient(129deg, #0ccb84 0%, #25ceed 100%);

      font-weight: 500;
      color: #ffffff;
    }
  }
  .swiper-container {
    margin-top: 1px;
  }
  .swiper-slide {
    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #d7effe;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #2ea5fc;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 52px;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 20px;
    }

    .tag {
      margin-bottom: 24px;
      margin-top: 48px;
      width: 160px;
      height: 56px;
      background: linear-gradient(
        129deg,
        rgba(17, 216, 141, 0.16) 0%,
        rgba(37, 206, 237, 0.16) 100%
      );
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #00b589;
      line-height: 56px;
    }

    .target {
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;

      margin-bottom: 64px;

      p {
        line-height: 44px;
        padding-left: 22px;
        position: relative;
        &::before {
          content: "";
          width: 8px;
          height: 8px;
          background: #00b589;
          opacity: 0.4;
          border-radius: 50%;

          top: 16px;
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
</style>
